<template>
  <section class="page-section">
        <el-tabs v-model="tabName" type="card" @tab-click="handleTabsChange">
          <el-tab-pane label="销售中" name="1"></el-tab-pane>
          <el-tab-pane label="已售罄" name="2"></el-tab-pane>
          <el-tab-pane label="仓库中" name="0"></el-tab-pane>
        </el-tabs>

        <!-- filter -->
        <div class="filter-region">
          <div class="filter-form">
            <el-form size="small" :inline="true" :model="filterForm" ref="filterForm">
              <el-form-item label="项目：" prop="name">
                <el-input v-model="filterForm.name" placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="服务分类：" prop="carOne">
                <el-select filterable v-model="filterForm.carOne" placeholder="请选择"
                  @change="handleFilterFormFirstCategoryChange">
                  <el-option v-for="item in firstCategoryOptions" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="" prop="carTwo">
                <el-select filterable v-model="filterForm.carTwo" placeholder="请选择" @change="secondCategoryIdEvent">
                  <el-option v-for="item in secondCategoryOptions" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="上架时间：" prop="time" class="auto-width">
                <el-date-picker v-model="filterForm.time" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-btn">
            <el-button-group class="btn-group">
              <el-button plain class="btn-reset" icon="el-icon-refresh"
                @click="filterFormReset('filterForm')"></el-button>
              <el-button type="primary" class="btn-search" @click="filterFormSubmit('filterForm')"
                :loading="tableLoading">查询</el-button>
            </el-button-group>
          </div>
        </div>
        <el-button class="btn-add-block" type="primary" @click="pageNavigateToGoodsManageAdd">发布服务</el-button>
        <!-- table -->
        <div class="table-region" v-loading="tableLoading">
          <el-table size="small" :data="tableData" ref="multipleTable" @selection-change="handleTableSelectionChange">
            <el-table-column type="selection" width="42"></el-table-column>
            <el-table-column label="项目" width="200">
              <template slot-scope="scope">
                <div class="goods-title">
                  <div class="thumb-wrap">
                    <img :src="scope.row.pic">
                  </div>
                  <p>{{ scope.row.name }}</p>
                  <p>备注：{{ scope.row.remark }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="排序" sortable sort-by="sequence">
              <template slot-scope="scope">
                <!-- <template v-if="scope.row.sequence !== 0"> -->
                <el-input type="number" :min="1" :max="9999999999" v-model="scope.row.sequence"
                  :disabled="tabName != '1'" style="width: 50px;"
                  @blur="handleSeqChange(scope.row, scope.$index)"></el-input>
                <!-- </template> -->
              </template>
            </el-table-column>
            <el-table-column label="一级分类">
              <template slot-scope="scope">
                <p>{{ scope.row.firstCategoryName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="二级分类">
              <template slot-scope="scope">
                <p>{{ scope.row.secondCategoryName }}</p>
              </template>
            </el-table-column>
            <el-table-column label="尘峰项目编码">
              <template slot-scope="scope">
                <p>{{ scope.row.externalGoodsCode || '未关联' }}</p>
              </template>
            </el-table-column>
            <el-table-column label="价格(人民币)" sortable sort-by="price">
              <template slot-scope="scope">
                <p>
                  ￥{{ scope.row.price }}&nbsp;
                  <!-- 价格 -->
                  <template v-if="scope.row.unit === 0">
                    <el-popover placement="top" width="auto" v-model="scope.row.editPriceVisible"
                      popper-class="confirm-popover" v-if="!tableLoading">
                      <el-input type="number" v-model="scope.row.price"></el-input>

                      <div>
                        <el-button size="small" type="default" plain
                          @click="scope.row.editPriceVisible = false">取消</el-button>
                        <el-button size="small" type="primary" @click="handleSavePrice(scope.row)"
                          :loading="operateLoading">确定</el-button>
                      </div>

                      <el-button size="small" type="text" icon="el-icon-edit" slot="reference"
                        class="button-edit"></el-button>
                    </el-popover>
                  </template>
                </p>
                <p style="text-decoration: line-through;" v-if="scope.row.linePrice">￥{{ scope.row.linePrice }}</p>
              </template>
            </el-table-column>
            <el-table-column label="价格(韩元)" sortable sort-by="koreaPrice">
              <template slot-scope="scope">
                <p>
                  ₩{{ scope.row.koreaPrice }}&nbsp;
                  <!-- 价格 -->
                  <template v-if="scope.row.unit === 1">
                    <el-popover placement="top" width="auto" v-model="scope.row.editPriceVisible"
                      popper-class="confirm-popover" v-if="!tableLoading">
                      <el-input type="number" v-model="scope.row.price"></el-input>

                      <div>
                        <el-button size="small" type="default" plain
                          @click="scope.row.editPriceVisible = false">取消</el-button>
                        <el-button size="small" type="primary" @click="handleSavePrice(scope.row)"
                          :loading="operateLoading">确定</el-button>
                      </div>

                      <el-button size="small" type="text" icon="el-icon-edit" slot="reference"
                        class="button-edit"></el-button>
                    </el-popover>
                  </template>
                </p>
                <p style="text-decoration: line-through;" v-if="scope.row.lineKoreaPrice">₩{{ scope.row.lineKoreaPrice
                }}</p>
              </template>
            </el-table-column>
            <el-table-column label="库存" sortable sort-by="stock">
              <template slot-scope="scope">
                <p>
                  {{ scope.row.stock }}&nbsp;
                  <!-- 库存 -->
                  <el-popover placement="top" width="auto" v-model="scope.row.editStockVisible"
                    popper-class="confirm-popover" v-if="!tableLoading">
                    <el-input type="number" v-model="scope.row.stock"></el-input>

                    <div>
                      <el-button size="small" type="default" plain
                        @click="scope.row.editStockVisible = false">取消</el-button>
                      <el-button size="small" type="primary" @click="handleSaveStock(scope.row)"
                        :loading="operateLoading">确定</el-button>
                    </div>

                    <el-button size="small" type="text" icon="el-icon-edit" slot="reference"
                      class="button-edit"></el-button>
                  </el-popover>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="总销量" sortable sort-by="saleNum">
              <template slot-scope="scope">
                <p>{{ scope.row.saleNum > 0 ? scope.row.saleNum : '-' }}</p>
              </template>
            </el-table-column>
            <el-table-column label="上架时间" sortable sort-by="createDate">
              <template slot-scope="scope">
                <p>{{ scope.row.onlineDate ? COMMON.formatDate('2', '-', scope.row.onlineDate) : '-' }}</p>
              </template>
            </el-table-column>
            <!-- <el-table-column label="是否小程序展示">
              <template slot-scope="scope">
                <p>未设置</p>
              </template>
            </el-table-column> -->
            <el-table-column label="操作" align="right">
              <template slot-scope="scope">
                <el-button size="small" type="text" @click="pageNavigateToGoodsManageAdd(scope.row)">编辑</el-button>

                <!-- <el-button v-if="tabName == '1'" size="small" type="text" @click="handleSort(scope.row)">{{ scope.row.sequence == 1 ? '取消置顶' : '置顶' }}</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="table-footer" v-if="page.total > 0">
          <div class="selection-operate">
            <el-checkbox v-model="allSelect" @change="handleAllSelectChange">全选当页</el-checkbox>
            <div class="button-wrap">
              <!-- 上架 -->
              <el-popover placement="top" width="165" v-model="operate.upVisible" popper-class="confirm-popover"
                v-if="tabName == 2 || tabName == 0">
                <p>上架后,可在"销售中"查看该项目，确定上架？</p>
                <div>
                  <el-button size="small" type="default" plain @click="handleOperateCancle">取消</el-button>
                  <el-button size="small" type="primary" @click="handleUpdateStatus(1)"
                    :loading="operateLoading">确定</el-button>
                </div>

                <el-button size="small" type="default" plain slot="reference">上架</el-button>
              </el-popover>

              <!-- 下架 -->
              <el-popover placement="top" width="165" v-model="operate.downVisible" popper-class="confirm-popover"
                v-if="tabName == 1 || tabName == 2">
                <p>{{ tabName == 1 ? '下架' : '放回仓库' }}后，可在"仓库中"查看该项目，确定{{ tabName == 1 ? '下架' : '放回仓库' }}？</p>
                <div>
                  <el-button size="small" type="default" plain @click="handleOperateCancle">取消</el-button>
                  <el-button size="small" type="primary" @click="handleUpdateStatus(0)"
                    :loading="operateLoading">确定</el-button>
                </div>

                <el-button size="small" type="default" plain slot="reference">{{ tabName == 1 ? '下架' : '放回仓库'
                }}</el-button>
              </el-popover>

              <!-- 删除 -->
              <el-popover placement="top" width="165" v-model="operate.deleteVisible" popper-class="confirm-popover">
                <p>确定删除该项目？</p>
                <div>
                  <el-button size="small" type="default" plain @click="handleOperateCancle">取消</el-button>
                  <el-button size="small" type="primary" @click="handleUpdateStatus(-1)"
                    :loading="operateLoading">确定</el-button>
                </div>

                <el-button size="small" type="default" plain slot="reference">删除</el-button>
              </el-popover>
            </div>
          </div>
          <div class="pagination-wrap">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :page-sizes="[20, 50, 100]" :pager-count="5" :current-page="page.current" :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper" :total="page.total">
            </el-pagination>
          </div>
        </div>

      </section>
</template>

<script>
import { COMMON, serviceManageList, commodityCategoryList, serviceManageUpdateStock, serviceManageUpdatePrice, serviceManageUpDown, serviceManageDelete, serviceManageSort, serviceManageListSort } from '@/common/api'

export default {
  name: 'goodsManageList',
  data() {
    return {
      COMMON,

      tabName: this.$route.query.name ? '' + this.$route.query.name : '1', //选项卡name

      filterForm: { //筛选表单值
        name: '', // 项目名
        carOne: '', // 一级类目
        carTwo: '', // 二级类目
        time: '', // 上架时间
      },
      firstCategoryOptions: [], // 一级商品类目下拉列表
      secondCategoryOptions: [], // 二级商品类目下拉列表

      tableLoading: true,
      tableData: [], //表格数据
      page: {
        current: 1,
        size: 20,
        total: 0
      },

      multipleSelection: [], // 选中的数据
      allSelect: false, //全选当页
      operate: {
        upVisible: false, // 上架
        downVisible: false, // 下架
        deleteVisible: false // 删除
      },
      operateLoading: false
    }
  },
  mounted() {
    this.getList();
    this.getFirstCategoryList();
  },
  methods: {
    /**
     * [handleTabsChange description] 切换选项卡
     * @param  {[type]} tab   [description] 取name值用tab.name
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    handleTabsChange: function (tab, event) {
      // 初始化状态
      this.filterForm = {
        name: '',
        carOne: '',
        carTwo: '',
        time: ''
      };
      this.secondCategoryOptions = [];

      this.page.current = 1;
      this.multipleSelection = [];
      this.allSelect = false;
      this.handleOperateCancle();

      this.getList();
    },
    /**
     * [getList description] 获取表格数据
     * @return {[type]} [description]
     */
    getList: function () {
      this.tableLoading = true;

      let time = this.filterForm.time
      let params = {
        status: this.tabName,
        name: this.filterForm.name,
        carOne: this.filterForm.carOne,
        carTwo: this.filterForm.carTwo,
        startTime: time && time.length > 1 ? new Date(time[0]).getTime() : '',
        endTime: time && time.length > 1 ? (new Date(time[1]).getTime() + 24 * 60 * 60 * 1000 - 1) : '',
        current: this.page.current,
        size: this.page.size
      }

      serviceManageList(params).then(res => {
        this.tableLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          let dataArray = data.records || [];

          this.tableData = dataArray;
          this.page.total = data.total;
          this.$nextTick(() => {
            const scrollContainer = document.querySelector('.app-container');
            if (scrollContainer) {
              scrollContainer.scrollTop = 0;
            }
          });
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    /**
     * [secondCategoryIdEvent description] 二级类目变化监听
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    secondCategoryIdEvent() {
      this.getCategoryLabelList(this.filterForm.carTwo);
    },
    /**
     * [handleSizeChange description] 分页每页条数变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleSizeChange(val) {
      this.page.current = 1;
      this.page.size = val;
      this.getList();
    },
    /**
     * [handleCurrentChange description] 选择分页第几页
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    /**
     * [getFirstCategoryList description] 获取一级商品下拉列表
     * @return {[type]} [description]
     */
    getFirstCategoryList: function () {
      let params = {
        type: 2
      }

      commodityCategoryList(params).then(res => {
        let { code, data, successInfo, msg } = res;

        if (code == 0) {
          let dataArray = data || [];

          this.firstCategoryOptions = dataArray;
        }
      });
    },
    /**
     * [handleFilterFormFirstCategoryChange description] 监听表单筛选一级商品类型变化
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    handleFilterFormFirstCategoryChange: function (val) {
      this.filterForm.carTwo = '';
      this.getSecondCategoryList();
    },
    /**
     * [getSecondCategoryList description] 根据一级商品类目获取二级类目下拉列表
     * @return {[type]} [description]
     */
    getSecondCategoryList: function () {
      let params = {
        type: 2,
        firstCategoryId: this.filterForm.carOne
      }

      commodityCategoryList(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          let dataArray = data || [];

          this.secondCategoryOptions = dataArray;
        }
      });
    },
    /**
     * [filterFormSubmit description] 提交筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormSubmit: function (formName) {
      this.page.current = 1;

      this.getList();
    },
    /**
     * [filterFormReset description] 重置筛选表单
     * @param  {[type]} formName [description]
     * @return {[type]}          [description]
     */
    filterFormReset: function (formName) {
      this.$refs[formName].resetFields();
      this.secondCategoryOptions = [];
    },
    /**
     * [handleTableSelectionChange description] table筛选选中状态变化
     * @param  {[type]} val [description] 选中行的数据集合array
     * @return {[type]}     [description]
     */
    handleTableSelectionChange: function (val) {
      if (val.length < this.tableData.length) {
        // 未全选中，改变底部全选状态
        this.allSelect = false;
      } else {
        this.allSelect = true;
      }

      this.multipleSelection = val;
    },
    /**
     * [handleAllSelectChange description] 全选
     * @param  {[type]} selected [description]
     * @return {[type]}          [description]
     */
    handleAllSelectChange: function (selected) {
      this.$refs.multipleTable.toggleAllSelection();
    },
    /**
     * [handleOperateCancle description] 操作popover - 取消
     * @return {[type]} [description]
     */
    handleOperateCancle: function () {
      this.operate = {
        upVisible: false,
        downVisible: false,
        deleteVisible: false
      }
    },
    /**
     * [handleUpdateStatus description] 商品上下架、删除
     * @param  {[type]} status [description]
     * @return {[type]}        [description]
     */
    handleUpdateStatus: function (status) {
      let statusName = '';
      if (status == 1) {
        statusName = '上架';
      } else if (status == 0) {
        statusName = this.tabName == 1 ? '下架' : '放回仓库';
      } else if (status == -1) {
        statusName = '删除';
      }


      if (this.multipleSelection.length == 0) {
        this.$message.error('请选择需要' + statusName + '的项目');
        this.handleOperateCancle();
        return false;
      }

      this.operateLoading = true;

      let ids = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        ids.push(this.multipleSelection[i].id);
      }

      if (status === 1 || status === 0) {
        // 上架、下架
        let params = {
          serviceIds: ids.join(','),
          status: status
        }

        serviceManageUpDown(params).then(res => {
          this.operateLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.$message({ message: statusName + '成功', type: 'success' });
            this.multipleSelection = [];
            this.handleOperateCancle();
            this.getList();
          } else {
            this.$message.error(msg);
          }
        }).catch(error => {
          this.operateLoading = false;
          this.$message.error('服务器异常');
        });
      } else if (status === -1) {
        // 删除
        let params = {
          serviceIds: ids.join(',')
        }

        serviceManageDelete(params).then(res => {
          this.operateLoading = false;

          let { code, data, msg } = res;

          if (code == 0) {
            this.$message({ message: statusName + '成功', type: 'success' });
            this.multipleSelection = [];
            this.handleOperateCancle();
            this.getList();
          } else {
            this.$message.error(msg);
          }
        }).catch(error => {
          this.operateLoading = false;
          this.$message.error('服务器异常');
        });
      }
    },
    /**
     * [pageNavigateToGoodsManageAdd description] 跳转到发布项目页面
     * @return {[type]} [description]
     */
    pageNavigateToGoodsManageAdd: function (row) {
      if (row) {
        this.$router.push({ path: '/service/manage/add', query: { id: row.id } });
      } else {
        this.$router.push({ path: '/service/manage/add' });
      }
    },
    /**
     * [handleSavePrice description] 保存编辑 - 价格
     * @return {[type]} [description]
     */
    handleSavePrice: function (row) {
      this.operateLoading = true;

      let params = {
        serviceId: row.id,
        price: row.price,
        unit: row.unit
      }

      serviceManageUpdatePrice(params).then(res => {
        this.operateLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          this.$message({ message: '保存成功', type: 'success' });
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.operateLoading = false;
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleSaveStock description] 保存编辑 - 库存
     * @return {[type]} [description]
     */
    handleSaveStock: function (row) {
      this.operateLoading = true;

      let params = {
        serviceId: row.id,
        stock: row.stock
      }

      serviceManageUpdateStock(params).then(res => {
        this.operateLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          this.$message({ message: '保存成功', type: 'success' });
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.operateLoading = false;
        this.$message.error('服务器异常');
      });
    },
    /**
     * [handleSort description] 置顶、取消置顶
     * @return {[type]} [description]
     */
    handleSort: function (row) {
      let params = {
        serviceId: row.id,
        top: row.sequence === 1 ? 0 : 1
      }

      serviceManageSort(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.$message({ message: '操作成功', type: 'success' });
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    },
    handleSeqChange(row, index) {
      const { sequence } = row
      const num = Number(sequence);
      if (!isNaN(num) && num > 0) {

      } else {
        this.$message.error('请输入大于0的数字');
        Object.assign(row, {
          sequence: ''
        })
        this.$set(this.tableData, index, row)
        return
      }

      let params = {
        serviceId: row.id,
        seq: row.sequence
      }

      serviceManageListSort(params).then(res => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.$message({ message: '操作成功', type: 'success' });
          this.getList();
        } else {
          this.$message.error(msg);
        }
      }).catch(error => {
        this.$message.error('服务器异常');
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

.goods-title {
  position: relative;
  padding-left: 58px;
  min-height: 48px;

  .thumb-wrap {
    @include position(absolute, 3, 50%, none, none, 0);
    width: 48px;
    height: 48px;
    margin-top: -24px;
    background-color: $colorPageBg;

    img {
      max-width: 100%;
      max-height: 100%;
      @include position(absolute, 1, 50%, none, none, 50%);
      @include translate(-50%, -50%, 0);
    }
  }

  p {
    line-height: 1.4;

    &+p {
      margin-top: 5px;
    }
  }
}

.button-edit {
  display: none;
}

.el-table__row {
  &:hover {
    .button-edit {
      display: inline-block;
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}

.paticular-table {
  margin-top: 0;
  background-color: transparent;

  &::before {
    display: none;
  }

  .el-table__header-wrapper {}

  ::v-deep .el-table__body-wrapper {
    .el-table__body {
      .el-table__row {
        background-color: transparent;

        td {
          padding: 5px 0;
          border-bottom-color: #ebeef5;
          /*border-bottom-color: transparent;*/
        }
      }
    }
  }
}

// .page-container {
//   height: 100%;
// }

// .page-main {
//   flex: 1;
//   overflow: hidden;
//   display: flex;
//   flex-direction: column;
// }

// .page-section {
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   overflow: hidden;

//   >.el-tabs {
//     flex-shrink: 0;
//   }

.btn-add-block {
  // flex-shrink: 0;
  align-self: flex-start;
  // margin-bottom: 20px;
}

// }

.filter-region {
  // flex-shrink: 0; // 筛选区域不压缩
  display: flex;
  align-items: center;
  justify-content: space-between;


  .filter-btn {
    height: 100%;

    .btn-group {
      display: flex;

      .btn-reset {
        width: 40px;
        height: 40px;
        border-color: #3388ff;
        color: #3388ff;
      }

      .btn-search {
        width: 84px;
        height: 40px;
      }

      .el-button {
        &+.el-button {
          margin-left: -1px !important;
        }

        &:first-child {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        &:last-child {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
        }
      }
    }
  }


}

.table-region {
  // flex: 1; // 占用剩余高度
  // display: flex;
  // flex-direction: column;
  // overflow: hidden;
  margin-bottom: 50px;

  :deep(.el-table) {
    // flex: 1;

    &::before {
      height: 0;
    }

    // 强制修正单元格高度同步问题
    td {
      padding: 8px 0 !important;
    }

    .cell {
      line-height: normal !important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  // 修复固定列头部背景色不一致问题
  :deep(.el-table__fixed-right-patch) {
    background-color: #f6f7f9;
    border-bottom: none;
  }

  :deep(.el-table__fixed-right) {
    thead th {
      background-color: #f6f7f9;
      border-bottom: none;
    }

    &::before {
      height: 0;
    }
  }

  // .table-footer {
  //   flex-shrink: 0; // 分页区域不压缩，保持固定高度
  // }
}
</style>
